import { CSSProperties } from 'react';

import { colors } from '@proprioo/salatim';

export const DEFAULT_ZOOM = 11;
export const SQUAD_VIEW_ZOOM = 9;
export const LOCATION_VIEW_ZOOM = 15;
export const SHOW_IRIS_INFO_ZOOM = 16;

export const DEFAULT_MARKER_PROPS = {
  clickable: false,
  icon: {
    fillOpacity: 0,
    path: 'M150 0 L75 200 L225 200 Z',
    strokeOpacity: 0
  }
};

export const STYLE_MAP: CSSProperties = {
  height: '100%',
  position: 'relative'
};

export const STYLE_POLYGON_AGENT = {
  fillColor: colors.dark.base,
  fillOpacity: 0.5,
  strokeColor: colors.dark.base,
  strokeOpacity: 0.3,
  strokeWeight: 2,
  zIndex: 1
};

export const STYLE_POLYGON_AREA = {
  clickable: true,
  draggable: false,
  editable: false,
  fillColor: colors.grey.base,
  fillOpacity: 0.3,
  geodesic: true,
  strokeColor: colors.dark.base,
  strokeOpacity: 0.3,
  strokeWeight: 1,
  zIndex: 0
};
